var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseButton = function SvgCloseButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#231727",
    d: "M3.386 1.121 0 3.927l8.396 8.638-6.703 7.84 3.684 2.947 7.432-7.276L21.498 24 24 19.931l-7.363-7.503L24 2.526 21.056 0l-8.247 9.48z"
  })));
};
export default SvgCloseButton;